import React from 'react'
import { Button } from '@workwhile/ui'
import { useFormContext } from 'react-hook-form'
import { FiltersSchema } from './filtersSchema'
import { usePositionsContextValue } from '../../context/PositionsProvider'

export const SearchButton = () => {
  const {
    actions: { setPositionFilters, setCompanyFilters, setPagination },
  } = usePositionsContextValue()

  const {
    handleSubmit,
    formState: { isValid },
  } = useFormContext<FiltersSchema>()

  const onSubmit = (data: FiltersSchema) => {
    setPagination((prev) => ({
      ...prev,
      pageIndex: 0,
    }))
    setPositionFilters({
      positionIds: data.position.positionIds?.map((id) => id.id) ?? [],
      status: data.position.status,
      prescreenStatus: data.position.prescreenStatus,
    })
    setCompanyFilters({
      companyIds: data.company.companyIds?.map((id) => id.id) ?? [],
      companyGroupIds: data.company.companyGroupIds?.map((id) => id.id) ?? [],
    })
  }

  return (
    <Button
      block={false}
      kind="medium"
      onClick={handleSubmit(onSubmit)}
      disabled={!isValid}
    >
      Search
    </Button>
  )
}
